

export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery(function() {
      jQuery('.match').matchHeight();
      jQuery('.match-two').matchHeight();
      jQuery('.match-three').matchHeight();
      jQuery('.match-wrap').matchHeight();
      jQuery('.equal').matchHeight({byRow:false});
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    require('../components/swipers');
    require('../components/sidenav');
    require('../components/video');
    require('../components/titles');
    require('../components/portal');

  },
};
